module.exports = __webpack_public_path__ + "img/logoPay.075258d8.png";